export default __webpack_public_path__ + "assets/images/30ac0119.png";